// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","775":"6ad6ff22","1553":"fd608de4","4839":"f9f14221"}[chunkId] + ".chunk.css";
};